import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";

const EMOJIS = [
    "📚", "🎯", "🔥", "⚖️", "🛡️", "🧠", "💡", "📈", "📉", "📊",
    "🧭", "🗂️", "🧾", "🕵️", "🏛️", "🏦", "💼", "📌", "🔎", "🧪",
    "⭐", "✨", "🚀", "⚡", "🎓", "🧩", "🗝️", "📝", "✅", "❗",
    "⚠️", "🕐", "🌟", "🌱", "🎖️", "🏆", "🎨", "🌐", "🔒", "🔓",
    "💎", "🧱", "🧰", "🧮", "📎", "🖇️", "🔗", "🎲",
];

export default function EmojiPicker({ value, onChange, testid }) {
    const [open, setOpen] = useState(false);
    const pick = (e) => { onChange(e); setOpen(false); };
    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button type="button" variant="outline" className="h-10 w-14 text-xl" data-testid={testid || "emoji-picker-trigger"}>
                    {value || "📚"}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-72 p-2">
                <div className="grid grid-cols-8 gap-1" data-testid="emoji-grid">
                    {EMOJIS.map((e) => (
                        <button
                            key={e}
                            type="button"
                            onClick={() => pick(e)}
                            className={`flex h-8 w-8 items-center justify-center rounded-sm text-lg transition-colors hover:bg-primary/15 ${value === e ? "bg-primary/20 ring-1 ring-primary" : ""}`}
                            data-testid={`emoji-opt-${e}`}
                        >
                            {e}
                        </button>
                    ))}
                </div>
            </PopoverContent>
        </Popover>
    );
}
